import React, { Fragment } from "react";

import * as R from "ramda";

import { withProps } from "recompose";

import { Box, Card } from "./base";

import Embed from "./Embed";

export const Divider = withProps(({ side }) => ({
  borderColor: "divider",
  borderWidth: 2,
  borderBottom: true,
  mt: 1,
  mb: 3,
  flex: 1,
  [side === "right" ? "mr" : "ml"]: [3, 3, 4],
}))(Box);

const sideForIndex = (index) => (index % 2 === 0 ? "right" : "left");

const Alerts = ({ alerts, t, closed }) =>
  closed || R.isEmpty(alerts) || R.isNil(alerts) ? null : (
    <Card
      mb={3}
      mt={[1, 0]}
      px={[1, 2, 3]}
      pt={[1, 2]}
      pb={[0, 1]}
      borderRadius={[0, 0, 5]}
      position="relative"
    >
      {alerts.map((alert, index) => (
        <Fragment key={alert.id}>
          <Embed t={t} {...alert} />
          {index !== alerts.length - 1 && (
            <Divider key="divider" side={sideForIndex(index)} />
          )}
        </Fragment>
      ))}
    </Card>
  );

export default Alerts;



// WEBPACK FOOTER //
// ./src/components/Alerts.js